// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fee-info-page[data-v-7a836bca]  .el-tabs__header {\n  margin-bottom: 16px;\n}", ""]);
// Exports
module.exports = exports;
